import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "formulario",
  class: "py-12 bg-black text-white font-poppins min-h-screen"
}
const _hoisted_2 = { class: "container mx-auto px-4 max-w-6xl" }
const _hoisted_3 = { class: "border border-[#c4f023]/40 bg-[#121214] rounded-md shadow-lg mb-6 overflow-hidden" }
const _hoisted_4 = { class: "p-6" }
const _hoisted_5 = { class: "flex flex-wrap -mx-2 items-start justify-center" }
const _hoisted_6 = { class: "w-full px-2 md:w-5/12 mb-4 md:mb-0" }
const _hoisted_7 = { class: "text-sm text-red-400 p-error block min-h-[1.25rem] mt-1" }
const _hoisted_8 = { class: "w-full px-2 md:w-5/12 mb-4 md:mb-0" }
const _hoisted_9 = { class: "text-sm text-red-400 p-error block min-h-[1.25rem] mt-1" }
const _hoisted_10 = {
  key: 0,
  class: "w-full px-2 md:w-2/12"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "pi pi-spin pi-spinner"
}
const _hoisted_13 = {
  key: 1,
  class: "w-full px-2 md:w-2/12"
}
const _hoisted_14 = {
  key: 0,
  class: "space-y-6"
}
const _hoisted_15 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_16 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_17 = { class: "text-sm text-red-400 p-error" }
const _hoisted_18 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_19 = { class: "text-sm text-red-400 p-error" }
const _hoisted_20 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_21 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_22 = { class: "text-sm text-red-400 p-error" }
const _hoisted_23 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_24 = { class: "text-sm text-red-400 p-error" }
const _hoisted_25 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_26 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_27 = {
  key: 0,
  class: "flex items-center text-white"
}
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 1,
  class: "text-neutral-400"
}
const _hoisted_30 = { class: "flex items-center" }
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "text-sm text-red-400 p-error" }
const _hoisted_33 = {
  key: 0,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_34 = { class: "text-sm text-red-400 p-error" }
const _hoisted_35 = {
  key: 1,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_36 = { class: "text-sm text-red-400 p-error" }
const _hoisted_37 = {
  key: 2,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_38 = { class: "text-sm text-red-400 p-error" }
const _hoisted_39 = {
  key: 3,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_40 = { class: "text-sm text-red-400 p-error" }
const _hoisted_41 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_42 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_43 = { class: "text-sm text-red-400 p-error" }
const _hoisted_44 = { class: "space-y-4 mt-6 p-5 border border-neutral-800 bg-[#121214]/60 rounded-lg" }
const _hoisted_45 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_46 = { class: "w-full px-2 md:w-12/12" }
const _hoisted_47 = { class: "text-sm text-red-400 p-error" }
const _hoisted_48 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_49 = { class: "w-full px-2 md:w-12/12" }
const _hoisted_50 = { class: "text-sm text-red-400 p-error" }
const _hoisted_51 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_52 = { class: "text-sm text-red-400 p-error" }
const _hoisted_53 = {
  key: 0,
  class: "w-full px-2 md:w-6/12"
}
const _hoisted_54 = { class: "text-sm text-red-400 p-error" }
const _hoisted_55 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_56 = { class: "text-sm text-red-400 p-error" }
const _hoisted_57 = {
  key: 0,
  class: "w-full px-2 md:w-6/12"
}
const _hoisted_58 = { class: "text-sm text-red-400 p-error" }
const _hoisted_59 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_60 = { class: "w-full px-2 md:w-12/12" }
const _hoisted_61 = { class: "text-sm text-red-400 p-error" }
const _hoisted_62 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_63 = { class: "text-sm text-red-400 p-error" }
const _hoisted_64 = {
  key: 0,
  class: "w-full px-2 md:w-6/12"
}
const _hoisted_65 = { class: "text-sm text-red-400 p-error" }
const _hoisted_66 = { class: "space-y-6 bg-[#121214] p-6 rounded-lg border border-neutral-800" }
const _hoisted_67 = { class: "flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 pb-4 border-b border-neutral-800" }
const _hoisted_68 = { class: "flex items-start gap-3 cursor-pointer" }
const _hoisted_69 = { class: "text-sm text-red-400 p-error block mt-1" }
const _hoisted_70 = { class: "pt-4 border-t border-neutral-800" }
const _hoisted_71 = { class: "flex items-start gap-3 cursor-pointer" }
const _hoisted_72 = { class: "flex items-start gap-3 cursor-pointer" }
const _hoisted_73 = { class: "text-sm text-red-400 p-error block mt-1" }
const _hoisted_74 = { class: "flex flex-wrap py-2 mt-4" }
const _hoisted_75 = ["disabled"]
const _hoisted_76 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_77 = { class: "pi pi-check mr-2" }
const _hoisted_78 = {
  key: 1,
  class: "flex flex-wrap space-y-4 md:space-y-0 mt-6 py-4 border border-neutral-700 bg-[#121214] rounded-md shadow-lg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Select = _resolveComponent("Select")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_Form, {
        ref: "formRef",
        onSubmit: _ctx.onSubmit,
        "validation-schema": _ctx.schema,
        class: "space-y-4 text-white",
        onInvalidSubmit: _ctx.onInvalidSubmit
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[35] || (_cache[35] = _createElementVNode("div", { class: "w-full bg-[#1c1c20] text-white text-2xl text-center font-antonio-bold py-4 tracking-wider uppercase border-b border-neutral-700 flex items-center justify-center gap-2" }, [
                _createElementVNode("span", { class: "text-[#c4f023]" }, "★"),
                _createTextVNode(" Acreditación VIP "),
                _createElementVNode("span", { class: "text-[#c4f023]" }, "★")
              ], -1)),
              _createElementVNode("div", _hoisted_4, [
                _cache[34] || (_cache[34] = _createElementVNode("p", { class: "text-gray-300 text-sm md:text-base text-center mb-6" }, " Para comenzar, ingrese su código de invitación y número de DNI. ", -1)),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[30] || (_cache[30] = _createElementVNode("label", { class: "block mb-1 font-semibold text-gray-200" }, "Código de invitación *", -1)),
                    _createVNode(_component_Field, {
                      name: "codigoInvitacion",
                      modelValue: _ctx.formData.codigoInvitacion,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.codigoInvitacion) = $event))
                    }, {
                      default: _withCtx(({ field, errors }) => [
                        _createVNode(_component_InputText, _mergeProps(field, {
                          type: "text",
                          placeholder: "Ej: VIP2026",
                          class: ["input-base uppercase", { 'opacity-70 bg-neutral-900 cursor-not-allowed': _ctx.formularioHabilitado, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                          readonly: _ctx.formularioHabilitado,
                          onBlur: _ctx.onCodigoBlur,
                          onKeydown: _withKeys(_withModifiers(_ctx.verificarInvitacionYDni, ["prevent"]), ["enter"])
                        }), null, 16, ["readonly", "class", "onBlur", "onKeydown"]),
                        _createElementVNode("span", _hoisted_7, [
                          _createVNode(_component_ErrorMessage, { name: "codigoInvitacion" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[31] || (_cache[31] = _createElementVNode("label", { class: "block mb-1 font-semibold text-gray-200" }, "DNI *", -1)),
                    _createVNode(_component_Field, {
                      name: "dni",
                      modelValue: _ctx.formData.dni,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.dni) = $event))
                    }, {
                      default: _withCtx(({ field, errors }) => [
                        _createVNode(_component_InputText, _mergeProps(field, {
                          type: "text",
                          placeholder: "Número de DNI",
                          class: ["input-base", { 'opacity-70 bg-neutral-900 cursor-not-allowed': _ctx.formularioHabilitado, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                          readonly: _ctx.formularioHabilitado,
                          onBlur: _ctx.onDniBlur,
                          onKeydown: _withKeys(_withModifiers(_ctx.verificarInvitacionYDni, ["prevent"]), ["enter"])
                        }), null, 16, ["readonly", "class", "onBlur", "onKeydown"]),
                        _createElementVNode("span", _hoisted_9, [
                          _createVNode(_component_ErrorMessage, { name: "dni" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  (!_ctx.formularioHabilitado)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _cache[32] || (_cache[32] = _createElementVNode("label", { class: "block mb-1 font-semibold text-transparent select-none hidden md:block" }, " ", -1)),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.verificarInvitacionYDni && _ctx.verificarInvitacionYDni(...args))),
                          disabled: _ctx.isValidatingDni,
                          class: "w-full py-2.5 px-4 bg-[#c4f023] hover:bg-[#b0d91f] text-black font-bold uppercase rounded transition cursor-pointer text-sm flex items-center justify-center gap-2"
                        }, [
                          (_ctx.isValidatingDni)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, _toDisplayString(_ctx.isValidatingDni ? 'Verificando...' : 'Verificar'), 1)
                        ], 8, _hoisted_11)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _cache[33] || (_cache[33] = _createElementVNode("label", { class: "block mb-1 font-semibold text-transparent select-none hidden md:block" }, " ", -1)),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.reiniciarForm && _ctx.reiniciarForm(...args))),
                          class: "w-full py-2.5 px-4 bg-neutral-800 hover:bg-neutral-700 text-gray-300 font-semibold uppercase rounded transition cursor-pointer text-xs flex items-center justify-center"
                        }, " Cambiar ")
                      ]))
                ])
              ])
            ]),
            (_ctx.formularioHabilitado)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _cache[63] || (_cache[63] = _createElementVNode("div", { class: "flex flex-wrap space-y-4 md:space-y-0 border border-neutral-700 bg-[#121214] rounded-md shadow-lg mb-6" }, [
                    _createElementVNode("div", { class: "w-full text-white text-2xl text-center font-antonio-bold py-4 tracking-wider uppercase" }, " Datos personales ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _cache[36] || (_cache[36] = _createElementVNode("label", { class: "block mb-1 font-semibold text-gray-200" }, "Nombre *", -1)),
                      _createVNode(_component_Field, {
                        name: "nombre",
                        modelValue: _ctx.formData.nombre,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.nombre) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            type: "text",
                            placeholder: "Nombre",
                            class: ["input-base", { 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                          }), null, 16, ["class"]),
                          _createElementVNode("span", _hoisted_17, [
                            _createVNode(_component_ErrorMessage, { name: "nombre" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _cache[37] || (_cache[37] = _createElementVNode("label", { class: "block mb-1 font-semibold text-gray-200" }, "Apellido *", -1)),
                      _createVNode(_component_Field, {
                        name: "apellido",
                        modelValue: _ctx.formData.apellido,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.apellido) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            type: "text",
                            placeholder: "Apellido",
                            class: ["input-base", { 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                          }), null, 16, ["class"]),
                          _createElementVNode("span", _hoisted_19, [
                            _createVNode(_component_ErrorMessage, { name: "apellido" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _cache[38] || (_cache[38] = _createElementVNode("label", { class: "block mb-1 font-semibold text-gray-200" }, "Correo electrónico *", -1)),
                      _createVNode(_component_Field, {
                        name: "mail",
                        modelValue: _ctx.formData.mail,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.mail) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            type: "email",
                            placeholder: "correo@ejemplo.com",
                            class: ["input-base", { 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                          }), null, 16, ["class"]),
                          _createElementVNode("span", _hoisted_22, [
                            _createVNode(_component_ErrorMessage, { name: "mail" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _cache[39] || (_cache[39] = _createElementVNode("label", { class: "block mb-1 font-semibold text-gray-200" }, "Teléfono celular (con código de área) *", -1)),
                      _createVNode(_component_Field, {
                        name: "telefonoCelular",
                        modelValue: _ctx.formData.telefonoCelular,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.telefonoCelular) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            type: "text",
                            placeholder: "Número (ej: 3511234567)",
                            class: ["input-base", { 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                          }), null, 16, ["class"]),
                          _createElementVNode("span", _hoisted_24, [
                            _createVNode(_component_ErrorMessage, { name: "telefonoCelular" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _cache[40] || (_cache[40] = _createElementVNode("label", { class: "block mb-1 font-semibold text-gray-200" }, "Desde dónde nos visitás (País) *", -1)),
                      _createVNode(_component_Field, {
                        name: "paisDomicilio",
                        modelValue: _ctx.formData.paisDomicilio,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.paisDomicilio) = $event))
                      }, {
                        default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                          _createVNode(_component_Select, {
                            filter: "",
                            onBlur: handleBlur,
                            "onUpdate:modelValue": handleChange,
                            "model-value": value,
                            class: _normalizeClass([{ 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }, "input-base"]),
                            placeholder: "País",
                            options: _ctx.paises,
                            optionLabel: "descripcion"
                          }, {
                            value: _withCtx((slotProps) => [
                              (slotProps.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    (slotProps.value.isocode)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: _ctx.getFlagUrl(slotProps.value.isocode),
                                          class: "mr-2 border border-neutral-600 rounded-sm",
                                          style: {"width":"20px","height":"auto"}
                                        }, null, 8, _hoisted_28))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", null, _toDisplayString(slotProps.value.descripcion), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(slotProps.placeholder), 1))
                            ]),
                            option: _withCtx((slotProps) => [
                              _createElementVNode("div", _hoisted_30, [
                                (slotProps.option.isocode)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: _ctx.getFlagUrl(slotProps.option.isocode),
                                      class: "mr-2 border border-neutral-600 rounded-sm",
                                      style: {"width":"20px","height":"auto"}
                                    }, null, 8, _hoisted_31))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", null, _toDisplayString(slotProps.option.descripcion), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["onBlur", "onUpdate:modelValue", "model-value", "class", "options"]),
                          _createElementVNode("span", _hoisted_32, [
                            _createVNode(_component_ErrorMessage, { name: "paisDomicilio" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    (_ctx.formData.paisDomicilio?.id === '+54')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _cache[41] || (_cache[41] = _createElementVNode("label", { class: "block mb-1 font-semibold text-gray-200" }, "Provincia *", -1)),
                          _createVNode(_component_Field, {
                            name: "provincia",
                            modelValue: _ctx.formData.provincia,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.provincia) = $event))
                          }, {
                            default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                              _createVNode(_component_Select, {
                                onBlur: handleBlur,
                                "onUpdate:modelValue": handleChange,
                                "model-value": value,
                                placeholder: "Seleccione la provincia",
                                options: _ctx.provincias,
                                optionLabel: "descripcion",
                                class: _normalizeClass(["input-base", { 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }])
                              }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                              _createElementVNode("span", _hoisted_34, [
                                _createVNode(_component_ErrorMessage, { name: "provincia" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.formData.paisDomicilio?.id === '+54')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _cache[42] || (_cache[42] = _createElementVNode("label", { class: "block mb-1 font-semibold text-gray-200" }, "Ciudad *", -1)),
                          _createVNode(_component_Field, {
                            name: "localidad",
                            modelValue: _ctx.formData.localidad,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.localidad) = $event))
                          }, {
                            default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                              _createVNode(_component_Select, {
                                onBlur: handleBlur,
                                filter: "",
                                "onUpdate:modelValue": handleChange,
                                "model-value": value,
                                placeholder: "Seleccione la ciudad",
                                class: _normalizeClass(["input-base", { 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }]),
                                options: _ctx.localidades,
                                optionLabel: "descripcion"
                              }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                              _createElementVNode("span", _hoisted_36, [
                                _createVNode(_component_ErrorMessage, { name: "localidad" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.formData.paisDomicilio?.id !== '+54')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _cache[43] || (_cache[43] = _createElementVNode("label", { class: "block mb-1 font-semibold text-gray-200" }, "Provincia / Estado *", -1)),
                          _createVNode(_component_Field, {
                            name: "provinciaEstado",
                            modelValue: _ctx.formData.provinciaEstado,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.provinciaEstado) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "text",
                                placeholder: "Ingrese su provincia o estado",
                                class: ["input-base", { 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                              }), null, 16, ["class"]),
                              _createElementVNode("span", _hoisted_38, [
                                _createVNode(_component_ErrorMessage, { name: "provinciaEstado" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.formData.paisDomicilio?.id !== '+54')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _cache[44] || (_cache[44] = _createElementVNode("label", { class: "block mb-1 font-semibold text-gray-200" }, "Ciudad *", -1)),
                          _createVNode(_component_Field, {
                            name: "localidadCiudad",
                            modelValue: _ctx.formData.localidadCiudad,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.localidadCiudad) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "text",
                                placeholder: "Ingrese su ciudad",
                                class: ["input-base", { 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                              }), null, 16, ["class"]),
                              _createElementVNode("span", _hoisted_40, [
                                _createVNode(_component_ErrorMessage, { name: "localidadCiudad" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _cache[45] || (_cache[45] = _createElementVNode("label", { class: "block mb-1 font-semibold text-gray-200" }, "Edad *", -1)),
                      _createVNode(_component_Field, {
                        name: "rangoEtario",
                        modelValue: _ctx.formData.rangoEtario,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.rangoEtario) = $event))
                      }, {
                        default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                          _createVNode(_component_Select, {
                            onBlur: handleBlur,
                            "onUpdate:modelValue": handleChange,
                            "model-value": value,
                            placeholder: "Seleccione su rango de edad",
                            class: _normalizeClass(["input-base", { 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }]),
                            options: _ctx.rangosEtarios,
                            optionLabel: "descripcion"
                          }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                          _createElementVNode("span", _hoisted_43, [
                            _createVNode(_component_ErrorMessage, { name: "rangoEtario" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _cache[64] || (_cache[64] = _createElementVNode("div", { class: "flex flex-wrap space-y-4 md:space-y-0 border border-neutral-700 bg-[#121214] rounded-md shadow-lg mt-11 mb-6" }, [
                    _createElementVNode("div", { class: "w-full text-white text-2xl text-center font-antonio-bold py-4 tracking-wider uppercase" }, " Información Institucional y Profesional ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _cache[46] || (_cache[46] = _createElementVNode("label", { class: "block mb-1 font-semibold text-gray-200" }, "Nombre de la Institución a la que pertenece (Nombre de la Empresa, Organización, Universidad o Institución a la que pertenece) *", -1)),
                        _createVNode(_component_Field, {
                          name: "empresa",
                          modelValue: _ctx.formData.empresa,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.empresa) = $event))
                        }, {
                          default: _withCtx(({ field, errors }) => [
                            _createVNode(_component_InputText, _mergeProps(field, {
                              type: "text",
                              placeholder: "Nombre de la Empresa, Organización, Universidad o Institución a la que pertenece",
                              class: ["input-base", { 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                            }), null, 16, ["class"]),
                            _createElementVNode("span", _hoisted_47, [
                              _createVNode(_component_ErrorMessage, { name: "empresa" })
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _cache[47] || (_cache[47] = _createElementVNode("label", { class: "block mb-1 font-semibold text-gray-200" }, "Profesión o Carrera en curso *", -1)),
                        _createVNode(_component_Field, {
                          name: "profesionCarrera",
                          modelValue: _ctx.formData.profesionCarrera,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.profesionCarrera) = $event))
                        }, {
                          default: _withCtx(({ field, errors }) => [
                            _createVNode(_component_InputText, _mergeProps(field, {
                              type: "text",
                              placeholder: "Profesión o carrera en curso",
                              class: ["input-base", { 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                            }), null, 16, ["class"]),
                            _createElementVNode("span", _hoisted_50, [
                              _createVNode(_component_ErrorMessage, { name: "profesionCarrera" })
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["w-full px-2", _ctx.formData.nivelResponsabilidad?.id === 'Otro (especificar)' ? 'md:w-6/12' : 'md:w-12/12'])
                      }, [
                        _cache[48] || (_cache[48] = _createElementVNode("label", { class: "block mb-1 font-semibold text-gray-200" }, "¿Cuál es tu nivel de responsabilidad? *", -1)),
                        _createVNode(_component_Field, {
                          name: "nivelResponsabilidad",
                          modelValue: _ctx.formData.nivelResponsabilidad,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.nivelResponsabilidad) = $event))
                        }, {
                          default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                            _createVNode(_component_Select, {
                              onBlur: handleBlur,
                              "onUpdate:modelValue": handleChange,
                              "model-value": value,
                              placeholder: "Seleccione su nivel de responsabilidad",
                              class: _normalizeClass(["input-base", { 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }]),
                              options: _ctx.nivelesResponsabilidad,
                              optionLabel: "descripcion"
                            }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                            _createElementVNode("span", _hoisted_52, [
                              _createVNode(_component_ErrorMessage, { name: "nivelResponsabilidad" })
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ], 2),
                      (_ctx.formData.nivelResponsabilidad?.id === 'Otro (especificar)')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                            _cache[49] || (_cache[49] = _createElementVNode("label", { class: "block mb-1 font-semibold text-gray-200" }, "Especificar nivel de responsabilidad *", -1)),
                            _createVNode(_component_Field, {
                              name: "nivelResponsabilidadOtro",
                              modelValue: _ctx.formData.nivelResponsabilidadOtro,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.nivelResponsabilidadOtro) = $event))
                            }, {
                              default: _withCtx(({ field, errors }) => [
                                _createVNode(_component_InputText, _mergeProps(field, {
                                  type: "text",
                                  placeholder: "Especifique su nivel de responsabilidad",
                                  class: ["input-base", { 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                                }), null, 16, ["class"]),
                                _createElementVNode("span", _hoisted_54, [
                                  _createVNode(_component_ErrorMessage, { name: "nivelResponsabilidadOtro" })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["w-full px-2", _ctx.formData.areaSector?.id === 'Otro (especificar)' ? 'md:w-6/12' : 'md:w-12/12'])
                      }, [
                        _cache[50] || (_cache[50] = _createElementVNode("label", { class: "block mb-1 font-semibold text-gray-200" }, "Área o sector principal *", -1)),
                        _createVNode(_component_Field, {
                          name: "areaSector",
                          modelValue: _ctx.formData.areaSector,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.areaSector) = $event))
                        }, {
                          default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                            _createVNode(_component_Select, {
                              onBlur: handleBlur,
                              "onUpdate:modelValue": handleChange,
                              "model-value": value,
                              placeholder: "Seleccione el área o sector principal",
                              class: _normalizeClass(["input-base", { 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }]),
                              options: _ctx.areasSector,
                              optionLabel: "descripcion"
                            }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                            _createElementVNode("span", _hoisted_56, [
                              _createVNode(_component_ErrorMessage, { name: "areaSector" })
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ], 2),
                      (_ctx.formData.areaSector?.id === 'Otro (especificar)')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                            _cache[51] || (_cache[51] = _createElementVNode("label", { class: "block mb-1 font-semibold text-gray-200" }, "Especificar área o sector *", -1)),
                            _createVNode(_component_Field, {
                              name: "areaSectorOtro",
                              modelValue: _ctx.formData.areaSectorOtro,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.areaSectorOtro) = $event))
                            }, {
                              default: _withCtx(({ field, errors }) => [
                                _createVNode(_component_InputText, _mergeProps(field, {
                                  type: "text",
                                  placeholder: "Especifique el área o sector",
                                  class: ["input-base", { 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                                }), null, 16, ["class"]),
                                _createElementVNode("span", _hoisted_58, [
                                  _createVNode(_component_ErrorMessage, { name: "areaSectorOtro" })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _cache[52] || (_cache[52] = _createElementVNode("label", { class: "block mb-1 font-semibold text-gray-200" }, "LinkedIn profesional, redes sociales o sitio web institucional (opcional)", -1)),
                        _createVNode(_component_Field, {
                          name: "redesSocialesLink",
                          modelValue: _ctx.formData.redesSocialesLink,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.redesSocialesLink) = $event))
                        }, {
                          default: _withCtx(({ field, errors }) => [
                            _createVNode(_component_InputText, _mergeProps(field, {
                              type: "text",
                              placeholder: "https://linkedin.com/in/... o enlace web",
                              class: ["input-base", { 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                            }), null, 16, ["class"]),
                            _createElementVNode("span", _hoisted_61, [
                              _createVNode(_component_ErrorMessage, { name: "redesSocialesLink" })
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _cache[65] || (_cache[65] = _createElementVNode("div", { class: "flex flex-wrap space-y-4 md:space-y-0 border border-neutral-700 bg-[#121214] rounded-md shadow-lg mt-11 mb-6" }, [
                    _createElementVNode("div", { class: "w-full text-white text-2xl text-center font-antonio-bold py-4 tracking-wider uppercase" }, " ¿Cómo te enteraste del evento? * ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["w-full px-2", _ctx.mostrarMedioOtro ? 'md:w-6/12' : 'md:w-12/12'])
                    }, [
                      _cache[53] || (_cache[53] = _createElementVNode("label", { class: "block mb-1 font-semibold text-gray-200" }, "Seleccione una o más opciones *", -1)),
                      _createVNode(_component_Field, {
                        name: "mediosSeleccionados",
                        modelValue: _ctx.formData.mediosSeleccionados,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.mediosSeleccionados) = $event))
                      }, {
                        default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                          _createVNode(_component_MultiSelect, {
                            onBlur: handleBlur,
                            "onUpdate:modelValue": handleChange,
                            "model-value": value,
                            placeholder: "Seleccione cómo se enteró del evento",
                            class: _normalizeClass(["input-base", { 'input-success': errors.length === 0 && value !== undefined && value.length > 0, 'input-error': errors.length > 0 }]),
                            options: _ctx.medios,
                            optionLabel: "descripcion",
                            showToggleAll: false
                          }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                          _createElementVNode("span", _hoisted_63, [
                            _createVNode(_component_ErrorMessage, { name: "mediosSeleccionados" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ], 2),
                    (_ctx.mostrarMedioOtro)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                          _cache[54] || (_cache[54] = _createElementVNode("label", { class: "block mb-1 font-semibold text-gray-200" }, "Otro medio (especificar) *", -1)),
                          _createVNode(_component_Field, {
                            name: "medioOtro",
                            modelValue: _ctx.formData.medioOtro,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.medioOtro) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "text",
                                placeholder: "Especifique cómo se enteró",
                                class: ["input-base", { 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                              }), null, 16, ["class"]),
                              _createElementVNode("span", _hoisted_65, [
                                _createVNode(_component_ErrorMessage, { name: "medioOtro" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _cache[66] || (_cache[66] = _createElementVNode("div", { class: "flex flex-wrap space-y-4 md:space-y-0 border border-neutral-700 bg-[#121214] rounded-md shadow-lg mt-11 mb-6" }, [
                    _createElementVNode("div", { class: "w-full text-white text-2xl text-center font-antonio-bold py-4 tracking-wider uppercase" }, " Política de Privacidad y Consentimiento ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _cache[56] || (_cache[56] = _createElementVNode("span", { class: "text-white font-semibold text-base" }, "Términos y condiciones del evento", -1)),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.mostrarModalPoliticas = true)),
                        class: "inline-flex items-center gap-2 px-4 py-2 bg-transparent hover:bg-white text-white hover:text-black border border-white font-medium rounded-md shadow-sm transition text-sm cursor-pointer font-space-mono"
                      }, _cache[55] || (_cache[55] = [
                        _createElementVNode("i", { class: "pi pi-file-o" }, null, -1),
                        _createTextVNode(" Ver políticas ")
                      ]))
                    ]),
                    _createElementVNode("div", null, [
                      _cache[58] || (_cache[58] = _createElementVNode("label", { class: "block font-bold text-white mb-2" }, " Autorización de uso y política* ", -1)),
                      _createVNode(_component_Field, {
                        name: "autorizoUsoYPolitica",
                        modelValue: _ctx.formData.autorizoUsoYPolitica,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.autorizoUsoYPolitica) = $event))
                      }, {
                        default: _withCtx(({ handleChange, value, errors }) => [
                          _createElementVNode("div", _hoisted_68, [
                            _createVNode(_component_Checkbox, {
                              "model-value": value,
                              binary: true,
                              inputId: "autorizoUsoYPolitica",
                              "onUpdate:modelValue": handleChange,
                              invalid: errors.length > 0,
                              class: "mt-0.5"
                            }, null, 8, ["model-value", "onUpdate:modelValue", "invalid"]),
                            _cache[57] || (_cache[57] = _createElementVNode("label", {
                              for: "autorizoUsoYPolitica",
                              class: "cursor-pointer text-sm text-gray-300 leading-snug"
                            }, " Acepto la política de protección de datos personales y consiento el uso de la información brindada para fines exclusivamente organizativos y de vinculación de Córdoba Tech Week y Córdoba Cluster. Autorizo el uso de mi imagen para registros fotográficos y audiovisuales de Córdoba Tech Week y Córdoba Cluster ", -1))
                          ]),
                          _createElementVNode("span", _hoisted_69, [
                            _createVNode(_component_ErrorMessage, { name: "autorizoUsoYPolitica" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _cache[61] || (_cache[61] = _createElementVNode("label", { class: "block font-bold text-white mb-2" }, " 📩 Comunicaciones* ", -1)),
                      _createVNode(_component_Field, {
                        name: "comunicaciones",
                        modelValue: _ctx.formData.comunicaciones,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData.comunicaciones) = $event))
                      }, {
                        default: _withCtx(({ handleChange, errors }) => [
                          _createElementVNode("div", {
                            class: _normalizeClass(["space-y-3", { 'text-red-400': errors.length > 0 }])
                          }, [
                            _createElementVNode("label", _hoisted_71, [
                              _createVNode(_component_RadioButton, {
                                modelValue: _ctx.formData.comunicaciones,
                                "onUpdate:modelValue": [
                                  _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.comunicaciones) = $event)),
                                  handleChange
                                ],
                                name: "comunicaciones",
                                value: "Si",
                                class: "mt-1",
                                invalid: errors.length > 0
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "invalid"]),
                              _cache[59] || (_cache[59] = _createElementVNode("span", { class: "text-sm text-gray-300 leading-snug" }, " Sí, quiero recibir novedades, actividades y contenidos de Córdoba Tech Week y Córdoba Cluster. Esto incluye confirmaciones, actualizaciones del cronograma, encuestas de satisfacción y futuras actividades vinculadas al ecosistema Córdoba Tech Week. Podés darte de baja en cualquier momento ", -1))
                            ]),
                            _createElementVNode("label", _hoisted_72, [
                              _createVNode(_component_RadioButton, {
                                modelValue: _ctx.formData.comunicaciones,
                                "onUpdate:modelValue": [
                                  _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.comunicaciones) = $event)),
                                  handleChange
                                ],
                                name: "comunicaciones",
                                value: "No",
                                class: "mt-1",
                                invalid: errors.length > 0
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "invalid"]),
                              _cache[60] || (_cache[60] = _createElementVNode("span", { class: "text-sm text-gray-300 leading-snug" }, " No quiero recibir novedades acerca el evento ", -1))
                            ])
                          ], 2),
                          _createElementVNode("span", _hoisted_73, [
                            _createVNode(_component_ErrorMessage, { name: "comunicaciones" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _cache[67] || (_cache[67] = _createElementVNode("div", { class: "flex flex-wrap space-y-4 md:space-y-0 mt-6 py-4 border border-neutral-700 bg-[#121214] rounded-md shadow-lg" }, [
                    _createElementVNode("div", { class: "w-full text-center font-semibold text-gray-200" }, " Para más información, podés escribirnos a "),
                    _createElementVNode("div", { class: "w-full text-center" }, [
                      _createElementVNode("a", {
                        href: "mailto:inscripciones@cordobacluster.com",
                        class: "text-white hover:text-[#c4f023] font-semibold underline"
                      }, "inscripciones@cordobacluster.com")
                    ])
                  ], -1)),
                  _cache[68] || (_cache[68] = _createElementVNode("div", { class: "flex flex-wrap space-y-4 md:space-y-0 mt-6 py-4 border border-neutral-700 bg-[#121214] rounded-md shadow-lg" }, [
                    _createElementVNode("div", { class: "w-full text-center font-semibold text-gray-200" }, " Te vamos a enviar un correo con más información del evento "),
                    _createElementVNode("div", { class: "w-full text-center font-normal text-gray-400 text-sm mt-1" }, " Por favor verificá el mismo para completar tu acreditación ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("button", {
                      type: "submit",
                      class: "mt-4 px-8 py-3.5 bg-transparent border-white hover:bg-white text-white font-semibold hover:text-black border-2 rounded text-lg transition duration-200 cursor-pointer font-space-mono",
                      disabled: _ctx.isSubmitting
                    }, [
                      _withDirectives(_createElementVNode("i", _hoisted_76, null, 512), [
                        [_vShow, _ctx.isSubmitting]
                      ]),
                      _withDirectives(_createElementVNode("i", _hoisted_77, null, 512), [
                        [_vShow, !_ctx.isSubmitting]
                      ]),
                      _cache[62] || (_cache[62] = _createTextVNode("REGISTRARME "))
                    ], 8, _hoisted_75)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_78, _cache[69] || (_cache[69] = [
                  _createElementVNode("div", { class: "w-full text-center font-semibold text-gray-200" }, " Para más información, podés escribirnos a ", -1),
                  _createElementVNode("div", { class: "w-full text-center" }, [
                    _createElementVNode("a", {
                      href: "mailto:inscripciones@cordobacluster.com",
                      class: "text-white hover:text-[#c4f023] font-semibold underline"
                    }, "inscripciones@cordobacluster.com")
                  ], -1)
                ])))
          ]),
          _createVNode(_component_BlockUI, {
            blocked: _ctx.isSubmitting,
            fullScreen: ""
          }, null, 8, ["blocked"])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "onInvalidSubmit"]),
      _createVNode(_component_Dialog, {
        visible: _ctx.mostrarModalPoliticas,
        "onUpdate:visible": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.mostrarModalPoliticas) = $event)),
        modal: "",
        header: "Política de Privacidad y Consentimiento",
        style: { width: '90vw', maxWidth: '720px' }
      }, {
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.mostrarModalPoliticas = false)),
            class: "px-5 py-2 bg-white hover:bg-gray-200 text-black font-semibold rounded-md text-sm cursor-pointer transition"
          }, " Entendido ")
        ]),
        default: _withCtx(() => [
          _cache[70] || (_cache[70] = _createElementVNode("div", { class: "space-y-4 text-sm text-gray-300 leading-relaxed max-h-[70vh] overflow-y-auto pr-2" }, [
            _createElementVNode("h3", { class: "font-bold text-base text-white border-b border-neutral-700 pb-2" }, "Leer política de Privacidad y Consentimiento"),
            _createElementVNode("div", null, [
              _createElementVNode("h4", { class: "font-bold text-white mb-1" }, "Responsable del tratamiento"),
              _createElementVNode("p", null, [
                _createTextVNode(" Los datos personales recabados a través del presente formulario serán tratados por "),
                _createElementVNode("strong", null, "Cluster Tecnológico Córdoba - Asociación Civil"),
                _createTextVNode(", CUIT 30-70782266-6, con domicilio en Avenida La Voz Del Interior 8851, piso 6, barrio Alta Córdoba, Córdoba Capital, en su carácter de organizador de Córdoba Tech Week 2026. ")
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h4", { class: "font-bold text-white mb-1" }, "Finalidad del tratamiento de datos personales"),
              _createElementVNode("p", null, "Los datos proporcionados serán utilizados exclusivamente para:"),
              _createElementVNode("ul", { class: "list-disc list-inside mt-1 space-y-1" }, [
                _createElementVNode("li", null, "Gestionar la inscripción y acreditación a Córdoba Tech Week 2026;"),
                _createElementVNode("li", null, "Organizar y coordinar la logística del evento y sus subeventos (Zona VIP, Cóctel, Ronda de Negocios, entre otros);"),
                _createElementVNode("li", null, "Enviar confirmaciones, actualizaciones de cronograma y comunicaciones operativas vinculadas a la participación;"),
                _createElementVNode("li", null, "En caso de haber prestado el consentimiento correspondiente, enviar novedades del ecosistema Córdoba Tech Week y compartir datos de contacto con empresas/instituciones aliadas.")
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h4", { class: "font-bold text-white mb-1" }, "Plazo de conservación"),
              _createElementVNode("p", null, " Los datos personales serán conservados durante el tiempo necesario para cumplir con las finalidades indicadas en la presente política de privacidad. En ningún caso los datos personales serán conservados ni utilizados para finalidades distintas de aquellas para las cuales el titular prestó su consentimiento. ")
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h4", { class: "font-bold text-white mb-1" }, "Compartir datos con empresas e instituciones (debes seleccionar una opción)"),
              _createElementVNode("p", null, " Al inscribirme, doy mi consentimiento para que Córdoba Tech Week / Córdoba Cluster comparta mis datos de contacto con empresas, instituciones y organizaciones participantes o aliadas del evento. "),
              _createElementVNode("p", { class: "mt-1" }, " El participante reconoce y acepta que sus datos serán comunicados a terceros, quienes serán responsables del tratamiento que realicen de dichos datos, sin que Córdoba Tech Week / Córdoba Cluster asuma responsabilidad por el uso, tratamiento o finalidad que dichos terceros puedan darles, una vez efectuada la comunicación. ")
            ]),
            _createElementVNode("div", { class: "space-y-3 pt-3 border-t border-neutral-700 text-xs text-gray-400" }, [
              _createElementVNode("h4", { class: "font-bold text-white text-sm" }, "A tener en cuenta:"),
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, "Uso de imagen:"),
                _createTextVNode(" Córdoba Tech Week 2026 es un evento masivo y abierto al público asistente, en el marco del cual se realizarán registros fotográficos y audiovisuales generales del evento (tomas de público, paneles, stands, actividades, etc.). Dicha captación se encuentra alcanzada por la excepción prevista en el art. 53, inc. c) del Código Civil y Comercial de la Nación (captación de imagen realizada en el marco de acontecimientos públicos o de interés general en los que participa el titular), por lo que no requiere consentimiento individual y podrá ser utilizada por Córdoba Tech Week y Córdoba Cluster con fines de cobertura, difusión institucional y promocional del evento (redes sociales, sitio web, publicidad y comunicaciones de futuras ediciones), en medios oficiales. Distinto es el caso de un uso individualizado o destacado de la imagen de una persona en particular (por ejemplo, entrevistas, testimoniales, piezas publicitarias centradas en un asistente identificado), para lo cual sí se solicitará el consentimiento específico de la persona en el momento correspondiente. ")
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, "Derechos de los titulares:"),
                _createTextVNode(" El titular de los datos personales tiene la facultad de ejercer el derecho de acceso a los mismos en términos de la Ley 25.326. Asimismo, podrá solicitar la rectificación, actualización o supresión de sus datos, y revocar en cualquier momento el consentimiento prestado, escribiendo a "),
                _createElementVNode("a", {
                  href: "mailto:info@cordobacluster.com",
                  class: "text-[#c4f023] underline"
                }, "info@cordobacluster.com"),
                _createTextVNode(", sin efecto retroactivo sobre los tratamientos ya realizados de forma lícita con anterioridad a la revocación. ")
              ]),
              _createElementVNode("p", null, " En particular, y conforme a lo ya señalado, la revocación no habilita a exigir la eliminación de material de cobertura general del evento (fotos, videos institucionales, piezas de difusión masiva), dado que dicha captación no depende del consentimiento individual sino de la excepción legal aplicable. ")
            ])
          ], -1))
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ], 64))
}